import { render, staticRenderFns } from "./AiChatPage.vue?vue&type=template&id=d36b5830&scoped=true"
import script from "./AiChatPage.vue?vue&type=script&lang=js"
export * from "./AiChatPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36b5830",
  null
  
)

export default component.exports